import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from "reactstrap";
import { DropdownFilter } from "../generics/Filter";
import PropTypes from "prop-types";

import { downloadPriceListsTemplate } from "../../store/priceLists/api";

const ModalUploadPricesList = ({ onSubmit, vendors, closeModal, isModalOpen }) => {
  const [file, setFile] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [description, setDescription] = useState(null);
  const [date, setDate] = useState(null);

  useEffect(() => {
    const today = new Date();
    setDate(today.toISOString().slice(0, 10));
  }, []);

  const handleChangeFile = (event) => {
    setFile(event.target.files[0]);
  };

  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleChangeDate = (event) => {
    setDate(event.target.value);
  };

  const handleChangeVendor = (event) => {
    setVendorId(event.target.value);
  };

  const handleTemplateDownload = () => {
    downloadPriceListsTemplate().then((r) => {
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Default price lists template.xlsx`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    });
  };

  return (
    <Modal isOpen={isModalOpen} toggle={closeModal} className={"modal-warning modal-logut"}>
      <ModalHeader toggle={closeModal} className="with-button">
        <span>Upload price list</span>
        <span className="btn btn-secondary m-0 mr-1" onClick={handleTemplateDownload}>
          Download template
        </span>
      </ModalHeader>
      <ModalBody>
        <span>Please upload the template file for the correct loading of all the items</span>
        <FormGroup className="mt-1">
          <Label className="mr-1 mb-0">List description</Label>
          <input className="form-control" type="text" value={description} onChange={handleChangeDescription} />
        </FormGroup>
        <FormGroup className="mt-1">
          <Label className="mb-0" for="exampleFile">
            Vendor
          </Label>
          <DropdownFilter colClass="col-auto" dropdownVal={vendorId} onDropdownChange={handleChangeVendor} dropdownOptions={vendors} />
        </FormGroup>
        <FormGroup>
          <Label style={{ width: 61 }} className="justify-content-start mb-0" for="exampleFile">
            Date
          </Label>
          <Input className="form-control" type="date" id="date" value={date} onChange={handleChangeDate} />
        </FormGroup>
        <FormGroup className="mb-0">
          <Label className="mr-1 mb-0 " for="exampleFile">
            Template File
          </Label>
          <Input type="file" name="to_update" id="to_update" accept=".csv, .xls, .xlsx" onChange={handleChangeFile} />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          disabled={!file || !date || !vendorId}
          onClick={() => onSubmit({ file, vendorId: vendors[vendorId].id, date, description })}
        >
          Upload
        </Button>
        <Button color="secondary" onClick={closeModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalUploadPricesList.propTypes = {
  onSubmit: PropTypes.func,
  vendors: PropTypes.array,
  closeModal: PropTypes.func,
  isModalOpen: PropTypes.func,
};

export default ModalUploadPricesList;
